import { render, staticRenderFns } from "./EditBundle.vue?vue&type=template&id=23f372f5&scoped=true"
import script from "./EditBundle.vue?vue&type=script&lang=js"
export * from "./EditBundle.vue?vue&type=script&lang=js"
import style0 from "./EditBundle.vue?vue&type=style&index=0&id=23f372f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f372f5",
  null
  
)

export default component.exports